export default {
    name: 'HasTypeProperties',
    props: {
        type: {type: String, required: true},
    },
};
